import EverythingYouNeed from "../components/views/users/home/EverythingYouNeed";
import FAQ from "../components/views/users/home/Faq";
import GetStarted from "../components/views/users/home/GetStarted";
import Hero from "../components/views/users/home/HeroPage";
import ManagementSolution from "../components/views/users/home/ManagementSolution";
import Platform from "../components/views/users/home/Platform";
import ProvenResult from "../components/views/users/home/ProvenResult";

const Home = () => {
  return (
    <div>
      <Hero />
      <ManagementSolution />
      <EverythingYouNeed />
      <ProvenResult />
      <Platform />
      <FAQ />
      <GetStarted />
    </div>
  );
};

export default Home;
